import { Component, Input } from '@angular/core';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { SharedModule } from '@shared/shared.module';
import { EndtNarrationComponent } from '../modal/endt-narration/endt-narration.component';
import { SortDirection, SortEvent } from '@aposin/ng-aquila/table';

@Component({
  selector: 'app-endt-history-table',
  standalone: true,
  imports: [
    SharedModule
  ],
  templateUrl: './endt-history-table.component.html',
  styleUrl: './endt-history-table.component.scss'
})
export class EndtHistoryTableComponent {
  @Input() endtHistoryList: any;
  @Input() lov: any;
  statusMap = {
    PRINTED: "Printed",
    APPROVED: "Approved",
    PENDING: "Pending \n Approval",
    CANCELLED: "Cancelled",
    SUBMITTED: "Submitted",
    ACTIVE: "Active",
    EXPIRED: "Expired"
  };
  classTypeMap = {
    PRINTED: "printed_badge",
    APPROVED: "approved_badge",
    PENDING: "pending_badge",
    CANCELLED: "cancel_badge",
    SUBMITTED: "submitted_badge",
    ACTIVE: "active_badge",
    EXPIRED: "expired_badge"
  };
  endtNarrationModal?: NxModalRef<EndtNarrationComponent>;

  constructor(
    private readonly dialogService: NxDialogService,
  ) {}

  getStatus(status) {
    return this.statusMap[status] || "";
  }
  
  getStatusColour(status) {
    return this.classTypeMap[status] || "";
  }

  getEndtType(endtType) {
    return this.lov.cnoteTypeList.find(e => e.code === endtType)?.descp;
  }

  openEndtNarrationPopUp(item) {
    //'<p><b><u>CANCELLATION OF POLICY - BY INSURED</u></b></p><p><br/>IT IS HEREBY DECLARED AND AGREED THAT EFFECTIVE <b>28/12/2023</b> THE POLICY IS CANCELLED.<br/></p><p><br/>IN CONSIDERATION OF THE ABOVE, A REFUND PREMIUM OF <b>RM6,086.10</b> IS HEREBY ALLOWED TO THE INSURED.<br/> </p><p><br/>NCD <b>0.00 %</b> on policy</p><br/>'
    this.endtNarrationModal = this.dialogService.open(EndtNarrationComponent, {
      showCloseIcon: false,
      disableClose: true,
      data: {
        endtNarration: item.endtNarration
      }
    });
  }

  async sortTable(sort: SortEvent, tableName: string) {
    let abc = this[tableName];
    this[tableName] = await abc.slice().sort((current, previous) => {
      if (sort.active === 'cnoteType') {
        let previousCnoteTypeDesc = this.getEndtType(previous.cnoteType);
        let currentCnoteTypeDesc = this.getEndtType(current.cnoteType);
        return this.compare(currentCnoteTypeDesc, previousCnoteTypeDesc, sort.direction);
      } else {
        return this.compare(current[sort.active], previous[sort.active], sort.direction);
      }
      
    });
  }

  compare(a, b, direction: SortDirection) {
    const isEmpty = v => v === null || v === undefined || v === '';

    if((isEmpty(a) && isEmpty(b)) || (a == b)) {
      return 0;
    }

    if(isEmpty(a)) {
      return direction === 'asc' ? -1 : 1;
    }

    if(isEmpty(b)) {
      return direction === 'asc' ? 1 : -1;
    }

    return (a < b ? -1 : 1) * (direction === 'asc' ? 1 : -1);
  }
}
